<template>
  <div class="outer" v-if="show && infoLoaded" @click.self="closeModule">
    <div class="content" :class="{short: other_group.length <= 0}">

      <div class="title">
        <div class="title-txt">
          <img src="./../../../assets/img/goods_detail/ic_coupon.png" alt>
          <span>优惠活动</span>
        </div>
        <img src="./../../../assets/img/payment/close.png" @click="closeModule" alt>
      </div>

      <!-- 当前券 -->
      <div class="box">
        <div class="coupon">
          <div class="up">
            <div class="right">
              <div class="discount-name"><span>{{ discount_condition.discount_name}}</span>折
                <br/>{{ (+coupon_detail.amount_limit) == 0 ? '无门槛' : '满'+(+coupon_detail.amount_limit)+'元可用'}}
              </div>
            </div>
            <div class="left">
              <div class="coupon-name" :class="{oneLine: coupon_detail.discount_type!=0}">
                <div class="user-limit" v-if="coupon_detail.discount_type==0">{{discount_condition.user_limit}}人拼团</div>
                <div>{{coupon_detail.name}}</div>
              </div>
              <div class="price" v-if="+coupon_detail.price>0">仅需
                <span class="cny-mark">¥</span>
                <span class="price-num">{{coupon_detail.price}}</span>
              </div>
            </div>
          </div>
          <div class="low">
            <div class="desc">
              <div class="disc">使用期限：{{timeStampToDate(coupon_detail.use_start_time)}} 至 {{timeStampToDate(coupon_detail.use_end_time)}}</div>
              <div class="disc">使用范围：{{coupon_detail.instructions}}</div>
            </div>
            <div class="main-coupon-btn" :class='{red: discount_condition.user_limit == 3, gray: !checkCouponStatus(coupon_detail).able}'
                 @click='openApp() || startGroup(coupon_detail)'
            >
              {{checkCouponStatus(coupon_detail).btnTxt}} <!-- 开团领券 -->
            </div>
          </div>
        </div>
      </div>

      <div class="related-group" v-if="other_group.length>0">
        <div class="mid-line"></div>

        <div class="next-title">
          <img src="./../../../assets/img/goods_detail/ic_shopping_bag.png" alt>
          <span>可直接参与的拼团</span>
        </div>

        <!-- 当前券 可直接参与的拼团 -->
        <div class="box joinAbleGroup">
          <div class="coupon small" v-for="(item, index) in other_group">
            <div class="left">
              <div class="quota">
                <div>{{item.limit_user}} 人<br/>团购</div>
              </div>
            </div>
            <div class="right">
              <div class="group-info">
                <div>{{item.group_user_name}}</div>
                <div class="rest">还差 <span>{{item.limit_user-item.exist_user}}</span> 人成团</div>
                <div>剩余时间
                  <span> {{secToTime(item.rest_time, "other_group", index).d}} </span>天
                  <span> {{secToTime(item.rest_time, "other_group", index).time}} </span>
                </div>
              </div>
              <div class="small-coupon-btn" @click="openApp() || joinGroup(item)">去拼团</div>
            </div>
          </div>
        </div>
      </div>

    </div>

    <pay
      :price="(+selected.price).toFixed(2)"
      :show.sync="isShowPay"
      @click-btn="goPay"
    ></pay>

    <pop
      :show.sync="isShowPop"
      :title="'领取成功'"
      :cancel-btn="'我知道了'"
      :confirm-btn="'立即使用'"
      :confirm-func="()=>{openApp(true)}"
    ></pop>

  </div>
</template>

<script>

// todo: 抽出与GroupCoupon公共部分, 以防难以维护

import {couponActivityInfo, couponJoinGroupCheck, couponJoinGroupPay, couponPay, couponPayCheck} from "@/api/api"
import group_coupon from "../../../js/group_coupon/group_coupon"
import utils from "../../../jslib/utils"
import Pop from "../../../component/Pop"
import Pay from "../../../component/pay/Pay"
import pay from "../../../js/group_coupon/pay"

export default {
  name: "coupon",
  components: {Pay, Pop},
  props: {
    show: {                // 弹出窗口
      type: Boolean,
      default: false
    },
    coupon_info: {          // 券信息
      type: Object,
      default: ()=>{return {}}
    }
  },
  data(){
    return{
      info: {},
      coupon_detail: [],
      my_group: [],
      other_group: [],

      infoLoaded: false,                     // 当前券信息加载完成

      discount_condition: {},

      selected:{
        coupon_id: undefined,
        group_id: undefined,
        price: '0.00',
        isFoundAGroup: true,
        discount_type: undefined
      },

      isShowPay: false,
      isShowPop: false,

      code: undefined,                        // 微信支付code
      inWechat: utils.getPlatform().weChat,

      openTime: 0,
      countDown: undefined,
    }
  },
  watch:{
    show(val){
      if(val) {
        this.network().getCouponInfo()
      }else{
        this.infoLoaded = false
      }
    }
  },
  created() {
    let {code} = this.$route.query

    this.countTime()

    if(utils.getPlatform().weChat) this.code = pay.getWxCode() || code
  },
  methods:{
    closeModule(){
      this.$emit('update:show', !this.show)
    },
    joinGroup(item){

      let {id, price} = item

      // 检查登录
      if(!this.checkLogin()) return

      this.markSelected(item, false)

      if(+price===0){
        this.network().checkAndClaimDirectly(id, 'group')
        return
      }

      this.network().couponJoinGroupCheck(id)

    },
    startGroup(item){

      let {id, price} = item

      // 检查登录
      if(!this.checkLogin()) return

      this.markSelected(item, true)

      if(+price===0){
        this.network().checkAndClaimDirectly(id, 'coupon')
        return
      }

      this.network().couponPayCheck(id)
    },
    markSelected(item, isFoundAGroup){
      let {id, price, discount_type} = item

      let type = isFoundAGroup ? 'coupon_id' : 'group_id'

      this.selected[type] = id
      this.selected.price = price
      this.selected.isFoundAGroup = isFoundAGroup
      this.selected.discount_type = discount_type
    },
    checkCouponStatus(item){

      // quantity_limit: 是否已达到限领数量: 0-否，1-是,如果达到，显示已领完
      // get_status: 允许领券状态: 0-未开始，1-进行中，2-已经结束
      // discount_type: 折扣类型: 0-拼团折扣，1-普通折扣
      let {quantity_limit, get_status, discount_type} = item

      let btnTxt = new Map([ [0, '开团领券'], [1, '立即领券'] ]).get(+discount_type)

      let status = { btnTxt, able: true }

      let gMap = new Map([[0,'未开始'],[1,btnTxt],[2,'已经结束']])
      let qMap = new Map([[0,btnTxt],[1,'已领完']])

      if( [0,2].includes(get_status) ){
        status = {btnTxt: gMap.get(get_status), able: false}
      }else if(quantity_limit == 1){
        status = {btnTxt: qMap.get(quantity_limit), able: false}
      }

      return status
    },
    jumpToDetail(group_id){
      if(this.inWechat){
        this.navigateTo(this.getDetailUrl(group_id))       // todo: 处理不是在app内部时的情况
      }else{
        this.navigateToNewAct(this.getDetailUrl(group_id, 1))
      }
    },
    getDetailUrl(group_id, is_inside){

      // 券团完成后跳转至团详情页; 普通券支付完成后 刷新当前页

      return this.selected.discount_type == 0 ?   // 0-团券 1-普通券
        'groupCouponDetail?is_inside=' + is_inside + '&group_id=' + group_id + '&activity_id=' + this.activity_id :
        (utils.getEnv() === 'web' ? utils.delUrlQS(this.$route.fullPath, 'code') : null)
    },

    // --- common ---
    openApp(wechatToBrowser){
      let is_inside = +this.is_not_inside === 1 ? 0 : 1

      return this.openApp_(is_inside, 'event', wechatToBrowser)
    },
    openApp_: group_coupon.openApp,

    // --- time ---
    timeStampToDate: group_coupon.timeStampToDate,
    secToTime_: group_coupon.secToTime,
    countTime(){
      this.countDown = setInterval(()=>{ this.openTime++ }, 1000)
    },
    secToTime(sec, arrName, index){
      sec -= this.openTime
      if(sec < 0) this[arrName].splice(index, 1)

      let {d,h,m,s} = this.secToTime_(sec)

      return {d, time: h + ':' + m + ':' + s}
      // return d + '天' + h + ':' + m + ':' + s
    },
    goPay(payMethod){
      console.log('支付方法', payMethod)

      let {isFoundAGroup, coupon_id, group_id, discount_type} = this.selected

      if(isFoundAGroup){

        // 微信内直接唤起支付
        if(this.inWechat){
          pay.arouseWechatPay(discount_type==0 ? 'couponPay' : 'regularCoupon', coupon_id)
        }else{
          this.network().couponPay(coupon_id, payMethod)
        }

      }else{

        // 微信内直接唤起支付
        if(this.inWechat){
          pay.arouseWechatPay('couponJoinGroupPay', group_id)
        }else{
          this.network().couponJoinGroupPay(group_id, payMethod)
        }

      }
    },


    network(){
      return {

        // 得到当前券信息
        getCouponInfo: async ()=>{
          // let data = testData
          let {data} = await couponActivityInfo({coupon_id: this.coupon_info.id})
          console.log("当前券详情", data)

          if(data.code==200){
            this.handle().getCouponInfo(data.data)
            this.infoLoaded = true
          }else{
            this.$uihelper.toast(data.message)
            this.closeModule()
          }
        },

        // 领券前检查
        couponPayCheck: async (coupon_id) => {
          let {data} = await couponPayCheck({coupon_id})
          console.log('检查领取', data)

          let {code, message} = data

          if(code == 200){
            if(this.inWechat){
              this.goPay('wechat')
            }else {
              this.isShowPay = !this.isShowPay
            }
          }else{
            this.$uihelper.toast(message)
          }

        },

        // 支付
        couponPay: async (coupon_id, pay_type) => {

          let {data} = await couponPay({coupon_id, pay_type})
          console.log('支付团券', data)

          let {group_id, order_num} = data.data

          this.handle().arouseAppPay(data, pay_type, this.getDetailUrl(group_id, 1))

        },

        // 直接领取
        checkAndClaimDirectly: async (id, idType)=>{

          let pay_type = 'wechat'                                  // xxx: 直接领券用”微信支付“
          let trade_type = new Map([
            ['web', 'JSAPI'],
            ['ios', 'APP'],
            ['android', 'APP']
          ]).get(utils.getEnv())
          let payment_author_code = this.code || sessionStorage.wx_code

          if(trade_type === 'JSAPI' && this.inWechat && !payment_author_code){
            this.$uihelper.toast('微信授权失败')
            return
          }

          switch (idType){
            case 'coupon':
              var {data} = await couponPayCheck({coupon_id: id})
              console.log('检查领取', data)

              var {code, message} = data
              if(code == 200){
                let {data} = await couponPay({coupon_id: id, pay_type, trade_type, code: payment_author_code})
                this.handle().popAfterClaim(data)
              }else {
                this.$uihelper.toast(message)
              }
              break;

            case 'group':
              var {data} = await couponJoinGroupCheck({group_id: id})
              console.log('加入团前检查', data)

              var {code, message} = data
              if(code == 200){
                let {data} = await couponJoinGroupPay({group_id: id, pay_type, trade_type, code: payment_author_code})
                this.handle().popAfterClaim(data)
              }else {
                this.$uihelper.toast(message)
              }
              break;
          }
        },

        // 加入团验证
        couponJoinGroupCheck: async (group_id) => {
          let {data} = await couponJoinGroupCheck({group_id})
          console.log('加入团前检查', data)

          let {code, message} = data

          if(code == 200){
            if(this.inWechat){
              this.goPay('wechat')
            }else{
              this.isShowPay = !this.isShowPay
            }
          }else{
            this.$uihelper.toast(message)
          }
        },

        // 加入团并支付
        couponJoinGroupPay: async (group_id, pay_type) => {

          let {data} = await couponJoinGroupPay({group_id, pay_type})
          console.log('加入团并支付', data)

          this.handle().arouseAppPay(data, pay_type, this.getDetailUrl(group_id, 1))

        }
      }
    },
    handle(){
      return{
        getCouponInfo: (data)=>{
          let {info, coupon_list, my_group, other_group} = data
          this.info = info
          this.coupon_detail = coupon_list[0]
          this.my_group = my_group
          this.other_group = other_group

          this.discount_condition = this.coupon_detail && this.coupon_detail.discount_condition
        },

        // 调起支付
        arouseAppPay: (data, pay_type, nextUrl) => {
          let {code, message} = data

          if(code == 200){
            this.payFromH5(data.data, pay_type, nextUrl)
            this.isShowPay = false
          }else{
            this.$uihelper.toast(message)
          }
        },

        // 直接领券后弹出\跳转
        popAfterClaim: (data)=>{
          let {code, message} = data
          if(code == 200 || code == 201){
            if(this.selected.discount_type==0){     // 0-团券 1-普通券

              let toastMsm = this.selected.isFoundAGroup ? '开团成功' : '加入团成功'
              this.$uihelper.toast(toastMsm)

              setTimeout(()=>{
                this.jumpToDetail(data.data.group_id)
              }, 1200)

            }else{
              // this.isShowPop = true                 // 弹出确认窗口
              this.$uihelper.toast('领取成功')
            }
          }else{
            this.$uihelper.toast(message)
          }
        },
      }
    },
  }
}
</script>

<style lang="scss" scoped>
@import "./merc_coupon";
</style>
